import React, { lazy } from 'react';
import { Check } from 'lucide-react';
const BONUSES = [{
  title: 'Respiraciones que Calman',
  subtitle: 'en 60 segundos',
  img: 'https://cdn.magicpatterns.com/uploads/oAVMLSeX3x7Yt9QGT67eZR/ChatGPT_Image_24_ene_2026,_10_45_55_p.m..png',
  desc: 'Corta un pico de ansiedad en cualquier lugar.'
}, {
  title: 'Rutinas Nocturnas',
  subtitle: 'para desactivar el modo alerta',
  img: 'https://cdn.magicpatterns.com/uploads/xaqLvvaU2RydaLARxW973P/ChatGPT_Image_24_ene_2026,_10_49_39_p.m..png',
  desc: 'Apaga la alerta antes de dormir.'
}];
const INCLUDES = ['Protocolo Calma-5™ completo', 'Guía paso a paso para usarlo en 5 minutos', 'Respiraciones que calman en 60 segundos', 'Rutinas nocturnas para dormir mejor', 'Acceso inmediato', 'Acceso de por vida'];
export function IncludesSection() {
  return <section className="py-20 bg-white px-4" data-id="element-180">
      <div className="max-w-6xl mx-auto" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6" data-id="element-183">
            Lo que recibes hoy
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-184">
          <div className="order-2 lg:order-1" data-id="element-185">
            <div className="grid grid-cols-2 gap-2" data-id="element-186">
              {INCLUDES.map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#FAF5EF] rounded-lg px-3 py-2" data-id="element-187">
                  <Check className="h-3.5 w-3.5 text-[#C06B6B] flex-shrink-0" data-id="element-188" />
                  <span className="text-sm text-gray-700" data-id="element-189">{item}</span>
                </div>)}
            </div>
          </div>
          <div className="order-1 lg:order-2 flex justify-center" data-id="element-190">
            <img src="https://cdn.magicpatterns.com/uploads/8U6jwPDsPXzUm5bwg9GMyE/ChatGPT_Image_24_ene_2026,_10_43_52_p.m..png" alt="Protocolo Calma-5™ - Paquete Completo" className="w-3/4 max-w-md shadow-2xl rounded-lg rotate-3 hover:rotate-0 transition-transform duration-500" loading="lazy" data-id="element-191" />
          </div>
        </div>

        {/* Bonuses */}
        <div className="bg-[#FAF5EF] rounded-3xl p-8 md:p-12" data-id="element-192">
          <h3 className="text-2xl font-serif font-bold text-center text-[#C4973B] mb-12" data-id="element-193">
            🎁 + 2 Bonos incluidos
          </h3>

          <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-194">
            {BONUSES.map((bonus, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-195">
                <img src={bonus.img} alt={bonus.title} className="w-48 shadow-xl rounded-md mb-6 hover:scale-105 transition-transform" loading="lazy" data-id="element-196" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-197">
                  {bonus.title}
                </h4>
                <p className="text-[#C06B6B] font-medium mb-2" data-id="element-198">
                  {bonus.subtitle}
                </p>
                <p className="text-sm text-gray-600 max-w-xs" data-id="element-199">{bonus.desc}</p>
              </div>)}
          </div>

          <div className="text-center pt-8 border-t border-[#C4973B]/20" data-id="element-200">
            <p className="text-gray-500 line-through mb-1" data-id="element-201">Valor total: $62</p>
            <p className="text-2xl font-bold text-[#C06B6B]" data-id="element-202">
              Hoy: $11.99 pago único
            </p>
            <p className="text-sm text-[#C06B6B]/80 font-semibold mt-1" data-id="element-203">
              Ahorras $35 hoy (77% descuento)
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-204">
              📲 Acceso inmediato · Disponible desde tu teléfono
            </p>
          </div>
        </div>
      </div>
    </section>;
}